<template>
    <v-form v-model="validForm">
        <h1>Inserimento/Modifica</h1>
        <v-text-field
            v-model="customerCode"
            :rules="rules.code"
            :label="trans('customers.fields.code')"
        ></v-text-field>

        <v-text-field
            v-model="customer.name"
            :rules="rules.name"
            :label="trans('customers.fields.name')"
            required
        ></v-text-field>

        <v-switch
            v-model="customer.active"   
            :label="trans('customers.fields.active')"
        ></v-switch>

        <v-text-field
            v-model="customer.referent"
            :label="trans('customers.fields.referent')"
        ></v-text-field>

        <v-text-field
            v-model="customer.address"
            :label="trans('customers.fields.address')"
        ></v-text-field>

        <v-text-field
            v-model="customer.zip_code"
            :label="trans('customers.fields.zip_code')"
        ></v-text-field>

        <v-text-field
            v-model="customer.city"
            :label="trans('customers.fields.city')"
        ></v-text-field>

        <v-text-field
            v-model="customer.province"
            :label="trans('customers.fields.province')"
        ></v-text-field>

        <v-text-field
            v-model="customer.country"
            :label="trans('customers.fields.country')"
        ></v-text-field>

        <v-text-field
            v-model="customer.website"
            :label="trans('customers.fields.website')"
        ></v-text-field>

        <v-text-field
            v-model="customer.email"
            type="email"
            :label="trans('customers.fields.email')"
        ></v-text-field>

        <v-text-field
            v-model="customer.phone"
            :label="trans('customers.fields.phone')"
        ></v-text-field>

        <v-text-field
            v-model="customer.vat"
            :label="trans('customers.fields.vat')"
        ></v-text-field>

        <v-text-field
            v-model="customer.fiscal_code"
            :label="trans('customers.fields.fiscal_code')"
        ></v-text-field>

        <v-text-field
            v-model="customer.sdi"
            :label="trans('customers.fields.sdi')"
        ></v-text-field>

        <v-text-field
            v-model="customer.pec"
            type="email"
            :label="trans('customers.fields.pec')"
        ></v-text-field>

        <v-btn @click="submit" color="primary" :disabled="!canSubmit"><v-icon left>send</v-icon>{{trans('common.save')}}</v-btn>
    </v-form>
</template>

<script>
    export default {
        name: 'customer-editor',
        props: {
            value: {
                type: Object,
                required: false
            },
            method: {
                type: String,
                required: true,
            },
        },
        data() {
            const customer = Object.assign({
                code: '',
                name: '',
                active: true,
                referent: '',
                address: '',
                zip_code: '',
                city: '',
                province: '',
                country: '',
                website: '',
                email: '',
                phone: '',
                vat: '',
                fiscal_code: '',
                sdi: '',
                pec: ''
            }, this.value || {});
            
            return {
                loading:false,
                validForm: true,
                customer,
                rules: {
                    code: [
                        (v) => (!v || (!!v && v.length >= 3)) || trans("customers.validations.code"),
                    ],
                    name: [
                        (v) => (!!v || (v.length >= 3)) || trans("customers.validations.name"),
                    ],
                },
            };
        },
        computed: {
            canSubmit() {
                return this.validForm;
            },
            isEdit() {
                return this.value?.id ? true : false;
            },
            customerCode: {
                get() {
                    return this.customer.code;
                },
                set(value) {
                    this.customer.code = value ? value.toUpperCase() : '';
                }
            }
        },
        methods: {
            submit() {
                this.loading = true;

                if (!this.validForm) {
                    console.warn('Form non valido.');
                    return;
                }

                const data = this.customer;

                if (this.isEdit) {
                    // UPDATE → PATCH su /customers/{id}
                    axios.patch('/customers/'+ this.value.id, data)
                        .then(response => {
                            if(response?.data?.result === 'ok' && response?.data?.redirect) {
                                window.location.href = response.data.redirect;
                            }
                        })
                        .catch(error => {
                            console.error('Errore durante l\'aggiornamento:', error);
                        }).finally(() => {
                            this.loading = false;
                        });
                } else {
                    // CREATE → POST su /customers
                    axios.post('/customers', data)
                        .then(response => {
                            if(response?.data?.result === 'ok' && response?.data?.redirect) {
                                window.location.href = response.data.redirect;
                            }
                        })
                        .catch(error => {
                            console.error('Errore durante la creazione:', error);
                        }).finally(() => {
                            this.loading = false;
                        });
                }
            },
            suggestCode() {
                if (!this.customer.name || this.customer.name.length < 3) {
                    console.warn('Name troppo corto per generare il codice.');
                    return;
                }

                axios.post('/customers/generate-code', { name: this.customer.name })
                    .then(response => {
                        if (response.data?.code) {
                            this.customer.code = response.data.code;
                        }
                    })
                    .catch(error => {
                        console.error('Errore nella generazione del codice:', error);
                    });
            }
        },
        watch: {
            'customer.name'(newVal) {
                if(!this.isEdit && !this.customer.code)
                    this.suggestCode();
            }
        }
    }
</script>